var render = function () {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("transition-group", { attrs: { name: "slide-fade" } }, [
          _vm.isBaixaDisabled()
            ? _c(
                "a",
                {
                  key: "suspen",
                  staticClass: "btn",
                  class:
                    ((_obj = {}),
                    (_obj[_vm.colorSelected] = _vm.isFieldChecked("suspensos")),
                    (_obj[_vm.colorDeselected] =
                      !_vm.isFieldChecked("suspensos")),
                    (_obj["btn-circle"] = _vm.isButtonCircle()),
                    _obj),
                  attrs: { href: "javascript:;" },
                  on: {
                    click: function ($event) {
                      return _vm.filterSelected("suspensos")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-clock-o" }),
                  _vm._v(" Suspenso\n            "),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row margin-top-15" }, [
      _c("div", { staticClass: "col-md-2" }, [
        _c(
          "a",
          {
            staticClass: "btn",
            class:
              ((_obj$1 = {}),
              (_obj$1[_vm.colorSelected] = _vm.isFieldChecked(
                "chkPrevisoesFirmeza"
              )),
              (_obj$1[_vm.colorDeselected] = !_vm.isFieldChecked(
                "chkPrevisoesFirmeza"
              )),
              (_obj$1["btn-circle"] = _vm.isButtonCircle()),
              _obj$1),
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.filterSelected("chkPrevisoesFirmeza")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-dollar" }),
            _vm._v(" Previsões\n            "),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.isFieldChecked("chkPrevisoesFirmeza") &&
      _vm.isClientesFornecedoresOrCliente()
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "col-md-3",
                staticStyle: { "margin-left": "10px" },
              },
              [
                _c("wes-range-slider", {
                  attrs: { id: "previsaoValue", value: _vm.getPrevisaoValue() },
                  on: { change: _vm.onChangePrevisaoFirmeza },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("span", { staticClass: "gerenciais-font" }, [
                _vm._v("% firmeza: "),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.previsao))]),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("hr"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }